import Project from './Project'
import Post from './Post'
import Media from './Media'
import Page from './Page'

export default {
  project: new Project(),
  post: new Post(),
  media: new Media(),
  page: new Page()
}
